module.exports = __webpack_public_path__ + "img/indexbanner.095228c0.png";